import isFunction from 'lodash.isfunction'

class StructuredValues {

  constructor (schema) {
    this.schema = schema;
  }

  rowTemplate(rowTemplate) {
    this.rowTemplate = rowTemplate;
  }

  defaultValueRender(item, key) {

    let value = null;

    if(item[key]) {
      if(item[key].trim().length > 0) {
        value = item[key].trim();
      }
    }

    if(value === null) {
      return '&ndash;';
    }

    return value;

  }

  render(item, whitelist=null) {

    let html = '';

    this.schema.forEach(row => {

      // only show whitelisted items for customization
      if(whitelist && !whitelist.includes(row.key)) {
        return;
      }

      let label = null;
      if (row.label && isFunction(row.label)) {
        label = row.label(item);
      } else {
        label = row.label;
      }

      let value = null;
      if (row.value && isFunction(row.value)) {
        value = row.value(item);
      } else {
        value = this.defaultValueRender(item, row.key);
      }

      if(value !== null) {

        let row_html = this.rowTemplate;

        row_html = row_html.replace(/\%key\%/g, row.key);
        row_html = row_html.replace(/\%label\%/g, label);
        row_html = row_html.replace(/\%value\%/g, value);

        html += row_html;

      }

    });

    return html;

  }

}

export default StructuredValues;